import { __rest } from "tslib";
import React from 'react';
import { Rating } from '@material-ui/lab';
import { RatingOutlined, RatingFilled } from '@next-common/material-ui-icons';
import { makeStyles } from "@material-ui/core";
const useStyles = makeStyles({
    iconFilled: {
        color: (props) => props.filledColor
    },
    iconEmpty: {
        color: (props) => props.emptyColor
    }
});
const StyledRating = (_a) => {
    var { emptyColor = '#FFCC00', filledColor = '#FFCC00', icon = React.createElement(RatingFilled, { fontSize: "inherit" }), emptyIcon = React.createElement(RatingOutlined, { fontSize: "inherit" }) } = _a, props = __rest(_a, ["emptyColor", "filledColor", "icon", "emptyIcon"]);
    const { iconFilled, iconEmpty } = useStyles({ filledColor, emptyColor });
    return (React.createElement(Rating, Object.assign({ classes: {
            iconFilled,
            iconEmpty
        }, icon: icon, emptyIcon: emptyIcon }, props)));
};
export default StyledRating;
